import { fromJS } from 'immutable';
import * as constants from './constants';

const defaultState = fromJS({
	videoId: null,
	videoUrl: '',
	studyTime: 0,
	lookTime: 0,
	lastCreateTime:'',
	lastStudyTime:'',
	courseInfo: {},
	teacherInfo: {},
	teacherArea: [],
	curTab: 'courseintro',
	courseDueTime: 'api----课程到期时间',
	addCommentContent: '',
	rateNum: null,
	commentPage: 1,
	commentTotal: null,
	commentList: [],
	solveList: [],
	askQuestionTitle: '',
	quillValue: '',
	solvePage: 1,
	solveTotal: null,
	notePage: 1,
	noteTotal: null,
	noteList: [],
	addNoteContent: '',
	isLoaderCommentShow: true,
	isLoaderSolveShow: true,
	isLoaderNoteShow: true,
})

export default ( state = defaultState, action ) => {console.log(action);
	switch(action.type) {

		case constants.SET_VIDEO_ID:
			return state.set('videoId', action.id);
		case constants.SET_VIDEO_URL:
			return state.set('videoUrl', action.url);
			// return state.set('videoUrl', 'https://vodpub2.v.news.cn/publish/20200513/XxjwsmE007003_20200513_CBVFN0A001.mp4');
		case constants.SET_VIDEO_STUDY_TIME:
			return state.set('studyTime', action.time);
		case constants.SET_VIDEO_LOOK_TIME:
			return state.set('lookTime', action.time);
		case constants.SET_VIDEO_lASTCREATE_TIME:
			return state.set('lastCreateTime', action.time);
		case constants.SET_VIDEO_lASTSTUDY_TIME:
				return state.set('lastStudyTime', action.time);
		case constants.SET_COURSE_INFO:
			return state.set('courseInfo', fromJS(action.data));
		case constants.SET_TEACHER_INFO:
			return state.set('teacherInfo', fromJS(action.data));
		case constants.SET_TEACHER_AREA:
			return state.set('teacherArea', fromJS(action.data));
		case constants.SET_COMMENT_LIST:
			return state.merge({
				'commentTotal': action.total,
				'commentList': fromJS(action.data)
			});
		case constants.SET_COMMENT_LOADER:
			return state.set('isLoaderCommentShow', action.value);
		case constants.SET_COMMENT_PAGE:
			return state.set('commentPage', action.value);
		case constants.CHANGE_TAB:
			return state.set('curTab', action.value);
		case constants.HANDLE_COMMENT_TEXTAREA_CHANGE:
			return state.set('addCommentContent', action.value);
		case constants.HANDLE_RATE_CHANGE:
			return state.set('rateNum', action.value);
		case constants.HANDLE_QUILL_CHANGE:
			return state.set('quillValue', action.value);
		case constants.HANDLE_ASK_QUESTION_INPUT_CHANGE:
			return state.set('askQuestionTitle', action.value);
		case constants.SET_SOLVE_LIST:
			return state.merge({
				'solveTotal': action.total,
				'solveList': fromJS(action.data)
			});
		case constants.SET_SOLVE_LOADER:
			return state.set('isLoaderSolveShow', action.value);
		case constants.SET_SOLVE_PAGE:
			return state.set('solvePage', action.value);
		case constants.SET_NOTE_LIST:
			return state.merge({
				'noteTotal': action.total,
				'noteList': fromJS(action.data)
			});
		case constants.SET_NOTE_LOADER:
			return state.set('isLoaderNoteShow', action.value);
		case constants.SET_NOTE_PAGE:
			return state.set('notePage', action.value);
		case constants.HANDLE_NOTE_TEXTAREA_CHANGE:
			return state.set('addNoteContent', action.value);
		default: 
			return state;
	}
}